import { useEffect, useState } from "react";
import { filterConstants } from "../../constants";

import { transactionStatus } from "../../enums";
import { useQueryString } from "../../hooks";
import {
  ITransactionBase,
  IQueryStringNavLinks,
  ITableHeader,
  ITransaction,
} from "../../interfaces-and-types";
import { transactionsData } from "../../test-data";
import { View } from "./View";

export interface ITransactionViewProps {
  data: ITransactionBase[];
  headers: ITableHeader[];
  isLoading: boolean;
  totalCount: number;
  queryStringTabs: IQueryStringNavLinks;

  // modals
  isCreateNewModalOpen: boolean;
  closeModal: () => void;

  // extra buttons
  onExport: () => void;
  onCreateNew: () => void;
}

export const Transactions = () => {
  const [isCreateNewModalOpen, setCreateNewModalOpen] = useState(false);
  const closeModal = () => {
    setCreateNewModalOpen(false);
  };

  const [isLoading, setisLoading] = useState(true);

  const query = useQueryString();
  const status = query.get(filterConstants.statusKey);

  useEffect(() => {
    setTimeout(() => setisLoading(false), 500);
  }, []);

  const headers: ITableHeader[] = [
    {
      key: "amount",
      header: "Amount",
    },
    {
      key: "status",
      header: "Status",
    },
    {
      key: "description",
      header: "Description",
    },
    {
      key: "customer",
      header: "Customer",
    },
    {
      key: "transactionType",
      header: "Transaction Type",
    },
    {
      key: "gateway",
      header: "Gateway",
    },
    {
      key: "date",
      header: "Date",
    },
    {
      key: "more",
      header: "",
    },
  ];

  const queryStringTabs: IQueryStringNavLinks = {
    query: filterConstants.statusKey,
    options: [
      {
        key: "All Transactions",
        value: "all",
      },
    ],
  };

  const queryFilteredData = transactionsData.filter(
    (kd) =>
      !status || status === "all" || transactionStatus[kd.status] === status
  );

  const onExport = () => {
    // export data via api and download
    alert("exporting data...");
  };
  const onCreateNew = () => {
    // openModal
    setCreateNewModalOpen(true);
  };

  return (
    <View
      data={queryFilteredData}
      headers={headers}
      isLoading={isLoading}
      totalCount={queryFilteredData.length}
      queryStringTabs={queryStringTabs}
      onExport={onExport}
      onCreateNew={onCreateNew}
      isCreateNewModalOpen={isCreateNewModalOpen}
      closeModal={closeModal}
    />
  );
};
